import { render, staticRenderFns } from "./ShwePush9002.vue?vue&type=template&id=47b9f4f8&scoped=true&"
import script from "./ShwePush9002.vue?vue&type=script&lang=js&"
export * from "./ShwePush9002.vue?vue&type=script&lang=js&"
import style0 from "./ShwePush9002.vue?vue&type=style&index=0&id=47b9f4f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b9f4f8",
  null
  
)

export default component.exports